import { Filter } from 'src/utils/composeFilter.ts';
import { HomePageData } from 'src/actuators/home/HomePageMapping.ts';

export function buildReadableFilterStatus(filter: Filter, data: HomePageData) {
    return Object.entries(filter)
        .sort(([name1], [name2]) => name1.localeCompare(name2))
        .reduce((acc, [name, filterValues]) => {
            const attributeValues = data?.[name as keyof HomePageData];
            if (attributeValues) {
                filterValues.forEach((currentValue) => {
                    const itemValue = attributeValues.values.find(({ value }) => value === currentValue);
                    if (itemValue) {
                        acc.push(itemValue.label);
                    }
                });
            }
            return acc;
        }, [] as string[])
        .join(', ');
}
